// When the GraphQL API responds with any error code we utilize this afterware
// to display some error messages in the snackbar.

import { chain } from 'lodash';
import router from '@/router';
import store from '@/store';

const redirectToErrorPage = (name, message) => {
  const query = { from: router.currentRoute.fullPath };
  query.message = JSON.stringify(message);
  router.replace({ name, query });
};

const ErrorHandler = {
  requestError(errors, next) {
    this.serverError(errors, next);
  },

  responseError(errors, next) {
    const errorWithCode = chain(errors)
      .filter(e => e.code)
      .sortBy(e => e.code)
      .head()
      .value();

    if (errorWithCode && errorWithCode.code) {
      switch (errorWithCode.code) {
        case 401:
          this.unauthorizedError(errorWithCode, next);
          break;
        case 403:
          this.forbiddenError(errorWithCode, next);
          break;
        case 404:
          this.notFoundError(errorWithCode, next);
          break;
        default:
          this.serverError(errorWithCode, next);
          break;
      }
    } else {
      this.serverError(errors[0], next);
    }
  },

  unauthorizedError(error, next) {
    store.dispatch('enforceLogout').then(() => {
      router.replace({
        name: 'login',
        query: { returnTo: router.currentRoute.fullPath },
      });
      next();
    });
  },

  forbiddenError(error, next) {
    redirectToErrorPage('forbidden', error);
    next();
  },

  notFoundError(error, next) {
    redirectToErrorPage('not-found', error);
    next();
  },

  serverError(error, next) {
    redirectToErrorPage('server-error', error);
    next();
  },
};

export default {
  applyAfterware({ response }, next) {
    // We need to clone the response to work around the following issues:
    // - https://github.com/apollographql/apollo-client/issues/774
    // - https://github.com/apollographql/apollo-client/pull/1425
    // - https://github.com/apollographql/apollo-client/issues/1530
    response.clone().json().then((clonedResponse) => {
      const errors = clonedResponse.errors;
      if (errors && errors.length) {
        if (response.status === 400) {
          ErrorHandler.requestError(errors, next);
        } else {
          ErrorHandler.responseError(errors, next);
        }
      } else {
        next();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./api/afterwares/error-handler.js